import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

import TypoContainer from '../../uikit/TypoContainer';
import { transformSource } from '../../utils/helpers';

import './AboutCompany.sass';

interface Props {
	title: string;
	text: string;
	sectionTitle: string;
}

function AboutCompany(props: Props) {
	const { title, text, sectionTitle } = props;
	return (
		<section className="about-company">
			<Container>
				<Row>
					<Col xs={12} className="about-company__heading">
						<h2 className="uikit-label-small-caps">{sectionTitle}</h2>
					</Col>
					<Col xs={12} md={6} lg={5}>
						{ReactHtmlParser(title, {
							transform: transformSource,
						})}
					</Col>
					<Col
						xs={12}
						md={6}
						lg={{ offset: 1, span: 6 }}
						className="about-company__text"
					>
						<TypoContainer markup={text} />
					</Col>
				</Row>
			</Container>
		</section>
	);
}

export default AboutCompany;
